export default "__VITE_ASSET__DQ0IEBOY__"